import { FC } from 'react';

export const MobilePass = (() => null) as FC;
